// extracted by mini-css-extract-plugin
module.exports = {"title":"title___2v-XM","container":"container___1vFB7","checkbox":"checkbox___C22V-"};